import { useEffect, useState, type RefObject } from 'react';

/**
 * Hook to determine if an element is out of view (above the viewport)
 * @param targetRef - Reference to the target element
 * @returns boolean - true if element is out of view, false otherwise
 */
export const useIsOutOfView = (targetRef: RefObject<HTMLElement | null>): boolean => {
  const [isOutOfView, setIsOutOfView] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const targetPosition = targetRef?.current?.getBoundingClientRect();

      setIsOutOfView(targetPosition ? targetPosition.bottom < 0 : false);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [targetRef]);

  return isOutOfView;
};
